<template>
  <div class="filters-group form-group">
    <button class="filters-group-heading collapsed" data-toggle="collapse" :href="`#collapse-${_uid}`">
      <span class="collapse-triangle"></span>
      <span class="filters-group-title">{{ label }}</span>
      <span v-if="isDirty" class="filters-group-dirty-indicator"></span>
    </button>
    <div class="filters-group-collapse collapse" :id="`collapse-${_uid}`">
      <div class="filters-group-collapse-content">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'FiltersGroup',
    props: {
      isDirty: {
        type: Boolean,
        default: false,
      },
      label: {
        type: String,
        required: true,
      },
    },
  }
</script>

<style lang="scss">
  @import "boot";
  $filters-group-collapse-half-base: .32em;
  $filters-group-collapse-height: .4em;
  $filters-group-padding-x: $filters-group-collapse-half-base * 2 + 1em;
  $filters-group-border-left-width: 4px;
  $filters-group-padding-top: .8em;
  $filters-group-padding-bottom: 1em;

  .filters-group {
    position: relative;
    margin-bottom: 0;
    + .filters-group {
      border-top: 1px solid $gray-lightest;
    }
    > .filters-group-heading {
      background: $gray-200;
      margin: 0;
      padding: .65em $filters-group-padding-x;
      display: block;
      width: 100%;
      text-align: left;
      position: relative;
      cursor: pointer;
      font-weight: $font-weight-bold;
      user-select: none;
      color: inherit;
      opacity: 0.9;
      border: none;
      border-left: $filters-group-border-left-width solid transparent;
      .collapse-triangle {
        position: absolute;
        left: .5em;
        top: 50%;
        margin-top: -$filters-group-collapse-half-base;
        width: $filters-group-collapse-half-base * 2;
        height: $filters-group-collapse-half-base * 2;
        text-align: center;
        display: inline-block;
        vertical-align: middle;
        &:before {
          content: '';
          display: inline-block;
          vertical-align: text-top;
          width: 0;
          height: 0;
          border-style: solid;
          border-width: $filters-group-collapse-height $filters-group-collapse-half-base 0 $filters-group-collapse-half-base;
          border-color: $body-color transparent transparent transparent;
          opacity: .7;
          transition: transform .1s ease;
        }
      }
      &:not(.collapsed) { // = open
        background: $gray-200;
        border-left-color: $primary;
        color: inherit;
        &:active {
          background: $gray-300;
        }
      }
      &.collapsed {
        background: transparent;
        &:hover {
          background: $gray-100;
          color: inherit;
          border-left-color: $gray-400;
        }
        &:active {
          background: $gray-200;
        }
        .collapse-triangle:before {
          transform: rotate(-90deg);
        }
      }
      &:hover, &:focus {
        opacity: 1;
        .collapse-triangle:before {
          opacity: 1;
        }
      }
      &:focus {
        outline: none;
        .collapse-triangle:before {
          border-top-color: $input-focus-border-color;
        }
      }
      .filters-group-dirty-indicator {
        $filters-group-dirty-indicator-size: .5rem;
        @include size($filters-group-dirty-indicator-size);
        border-radius: 50%;
        background-color: $primary;
        position: absolute;
        right: 0.8rem;
        top: 50%;
        margin-top: -($filters-group-dirty-indicator-size / 2);
      }
    }
  }
  .filters-group-title {
    font-size: 1.1em;
  }
  .filters-group-collapse {
    border-left: $filters-group-border-left-width solid $gray-500;
  }
  .filters-group-collapse-content {
    padding: $filters-group-padding-top $filters-group-padding-x $filters-group-padding-bottom;
    > .filters-group {
      margin-left: (-$filters-group-padding-x);
      margin-right: (-$filters-group-padding-x);
      &:first-child {
        margin-top: (-$filters-group-padding-top);
      }
      &:last-child {
        margin-bottom: (-$filters-group-padding-bottom);
      }
    }
  }
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/filters-group.vue